import $ from 'jquery';
import '../components/index';
import './index.scss';
import './CourseCard';

import './Home';
import './NewsList';
import './NoticeList';
import './NewsContent';
import './Login';
import './XueLiJiaoYu';
import './ZhiXue';
import './Special';
import './About';
import './Activity';
import './Course';
import './DangJian';
import './BaoMing';
import './BaiKe';
import './Sunshine';
import './Search';
import './SubjectContent';


$(() => {
//
});




/** WEBPACK FOOTER **
 ** ./src/index.js
 **/